
import { Vue, Options, prop } from "vue-class-component";
import Title from "@/app/ui/components/data-wrapper/title.vue";
import formatPhoneNumber from "@/app/infrastructures/misc/common-library/v2/FormatPhoneNumber";
import { AccountController } from "@/app/ui/controllers/AccountController";
import {
  DistrictFieldRules,
  getFieldRulesForDistrict,
  formatStoredPhoneForDisplay,
  formatStoredTaxIdForDisplay,
} from "@/app/infrastructures/misc/common-library/MalaysiaDistrictFieldRules";

class Props {
  detailData = prop<any>({
    type: Object,
    required: true
  });
  districtFieldRules = prop<DistrictFieldRules>({
    type: Object,
    default: () => getFieldRulesForDistrict("ID", "partner")
  });
}

@Options({
  components: {
    Title
  }
})
class DetailPartnerInformation extends Vue.with(Props) {
  get additionalCities() {
    if (this.detailData.partnerCity.length > 0) {
      return this.detailData.partnerCity
        .map((item: any) => item.name)
        .join(", ");
    }
    return "-";
  }
  mappingPosType(type: string) {
    const mapping: any = {
      "branch": "POS Child",
      "pickup": "POS Dipickup",
      "parent": "POS Parent"
    };
    return mapping[type];
  }
  get commissionBranchValue() {
    return this.detailData.partnerPosBranchCommission ? `${this.detailData.partnerPosBranchCommission}%` : "-"
  }
  get formattedConsolePhone() {
    return formatStoredPhoneForDisplay(this.detailData.partnerPhoneNumber, this.districtFieldRules);
  }
  get formattedTaxId() {
    return formatStoredTaxIdForDisplay(this.detailData.partnerTaxNumber, this.districtFieldRules);
  }
}
export default DetailPartnerInformation;
